import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Checkbox, type GetProp, Select } from 'antd'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LEGAL_FORMALITY_FIELD_OPTIONS_QUERY } from 'graphql/LegalFormalities'
import CentredLoader from 'components/CentredLoader'

interface IProps {
  nameKeys: string[]
  defaultValue?: any
  checkboxes?: boolean
  setCorrection: (value: string | string[]) => void
}

const FieldOptionsSelect = (props: IProps) => {
  const { nameKeys, defaultValue, checkboxes = false, setCorrection } = props
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const { data, loading } = useQuery(LEGAL_FORMALITY_FIELD_OPTIONS_QUERY, {
    variables: {
      id: legalFormality.id,
      fieldNames: nameKeys,
    },
    fetchPolicy: 'no-cache',
  })

  const handleCheckboxChange: GetProp<typeof Checkbox.Group, 'onChange'> = (
    checkedValues: string[]
  ) => {
    setCorrection(checkedValues)
  }

  if (loading) {
    return <CentredLoader />
  }

  const options = data.legalFormalityFieldOptions.fieldOptions.map(
    (option: string) => {
      return { value: option, label: option }
    }
  )

  return (
    <>
      {checkboxes ? (
        <Checkbox.Group
          options={options}
          defaultValue={defaultValue || []}
          onChange={handleCheckboxChange}
        />
      ) : (
        <Select
          defaultValue={defaultValue}
          style={{ width: 200 }}
          onChange={(value: string) => setCorrection(value)}
          options={options}
        />
      )}
    </>
  )
}

export default FieldOptionsSelect
